export default "__VITE_ASSET__fa758fa9__"